<fieldset [disabled]="isDisabled" class="requisition-text-column">
	<h4>Requisition Text</h4>
	<app-radio-group
		name="viewToggle"
		class="flex-none w-1/2"
		label="Select View"
		[(ngModel)]="viewOnly"
		[items]="items"
		type="compact"
		(ngModelChange)="updateParsedDoc()"
		[disabled]="isDisabled"
		[testHook]="testHooks.SelectViewRadioGroup"
	></app-radio-group>
	<app-requisition-text-areas
		name="requisitionTexts"
		[disabled]="viewOnly"
		[(ngModel)]="texts"
		[initialValueText]="initialRequisitionTexts"
	></app-requisition-text-areas>
</fieldset>
